import handleApiInvalidPasswordErrorIfPresent from '../handleApiInvalidPasswordErrorIfPresent';

export default async function () {
  const req = this.$store.dispatch('auth/logIn', {
    phone: this.phone,
    phone_country: this.phone_country,
    password: this.password,
  });

  try {
    await req;
  } catch (err) {
    const data = err?.response?.data;

    if (handleApiInvalidPasswordErrorIfPresent.call(this, err)) {
      return;
    }

    if (data?.error?.error_code === 'auth.invalid_password') {
      this.error = 'Неверный логин или пароль';
      return;
    }

    throw err;
  }

  this.page = 'done:signIn';
}
